export const SUPPLIER_LIST_REQUEST = 'SUPPLIER_LIST_REQUEST';
export const SUPPLIER_LIST_SUCCESS = 'SUPPLIER_LIST_SUCCESS';
export const SUPPLIER_LIST_FAIL = 'SUPPLIER_LIST_FAIL';